module.exports = __webpack_public_path__ + "media/images/charging-issue-8165efa30560a4663df364118dc10d30.svg";